import { PublicProfile } from "../PublicProfile.types";

export const mockPublicProfile: PublicProfile = {
  user: {
    id: "",
    avatarUrl: "",
    firstName: "Firstname",
    lastName: "Lastname",
    primaryEmailAddress: "email@domain.com",
    phoneNumber: {
      country: "US",
      countryCode: "1",
      number: "0000000000",
    },
    jobTitle: "Job title",
    createdAt: `${new Date()}`,
    country: "United States of America",
    certifications: [],
    credentials: [],
    electiveStudies: [],
  },
  training: {
    certifications: [
      {
        type: "GOLD",
        earnMethod: "Test",
        earnDate: new Date().toISOString(),
        status: "EARNED",
      },
      {
        type: "CORE",
        earnMethod: "Course",
        earnDate: new Date().toISOString(),
        status: "EARNED",
      },
      {
        type: "CORE",
        earnMethod: "Course",
        earnDate: new Date().toISOString(),
        status: "EARNED",
      },
    ],
    credentials: [
      {
        type: "CREDENTIAL",
        earnDate: new Date().toISOString(),
        status: "EARNED",
      },
      {
        type: "CREDENTIAL",
        earnDate: new Date().toISOString(),
        status: "EARNED",
      },
      {
        type: "CREDENTIAL",
        earnDate: new Date().toISOString(),
        status: "EARNED",
      },
    ],
    electiveStudies: [
      {
        id: "elective-1",
        name: "Building in Perspective",
        icon: "course-building-in-perspective",
        status: "COMPLETED",
        completedAt: new Date(),
        courseProgress: [],
      },
      {
        id: "elective-2",
        name: "Design Fundamentals",
        icon: "course-design-fundamentals",
        status: "COMPLETED",
        completedAt: new Date(),
        courseProgress: [],
      },
      {
        id: "elective-3",
        name: "Advanced Styling in Perspective",
        icon: "course-advanced-styling-in-perspective",
        status: "COMPLETED",
        completedAt: new Date(),
        courseProgress: [],
      },
      {
        id: "elective-4",
        name: "Ignition with Docker",
        icon: "course-ignition-with-docker",
        status: "COMPLETED",
        completedAt: new Date(),
        courseProgress: [],
      },
    ],
  },
};
